/**
 * TodoListSkeleton
 *
 * A skeleton loading state for the TodoList component
 */

import React from 'react'
import { cn } from '@/lib/utils'

interface TodoListSkeletonProps {
  className?: string
  itemCount?: number
}

export const TodoListSkeleton: React.FC<TodoListSkeletonProps> = ({ className, itemCount = 4 }) => {
  return (
    <div
      className={cn(
        'border-border bg-card my-4 flex animate-pulse flex-col overflow-hidden rounded-lg border shadow-sm transition-all',
        className
      )}
    >
      {/* Header */}
      <div className="flex items-center border-b p-3">
        <div className="flex items-center gap-2">
          <div className="size-4 rounded bg-gray-200 dark:bg-gray-700"></div>
          <div className="h-4 w-16 rounded bg-gray-200 dark:bg-gray-700"></div>
          <div className="h-4 w-12 rounded bg-gray-200 dark:bg-gray-700"></div>
        </div>
      </div>

      <div className="p-2">
        {/* Progress bar */}
        <div className="mb-3 h-1.5 w-full overflow-hidden rounded-full bg-gray-200 dark:bg-gray-700">
          <div className="h-full w-1/3 rounded-full bg-gray-300 dark:bg-gray-600"></div>
        </div>

        {/* Todo items */}
        <ul className="space-y-2">
          {[...Array(itemCount)].map((_, index) => (
            <li key={index} className="flex items-start gap-2 rounded-md p-2">
              <div className="mt-0.5 size-4 rounded bg-gray-200 dark:bg-gray-700"></div>
              <div className="h-4 flex-1 rounded bg-gray-200 dark:bg-gray-700"></div>
            </li>
          ))}
        </ul>

        {/* Controls */}
        <div className="mt-4 flex items-center gap-2 border-t pt-3">
          <div className="h-8 w-16 rounded bg-gray-200 dark:bg-gray-700"></div>
          <div className="h-8 w-24 rounded bg-gray-200 dark:bg-gray-700"></div>
        </div>
      </div>
    </div>
  )
}
